module.exports = __webpack_public_path__ + "static/media/family.8f70f375.jpg";